export function initSeoBlock($) {
  /* ========================================================================= \
  **  === seo-block                                                          *| 
  \ ========================================================================= */

  $('.blocs-seo--button').on('click', function () {
    var $wrapper = $(this).closest('.blocs-seo--wrapper'); // Trouver le wrapper commun
    var detailsHeightInnerSeo = $wrapper.find('.blocs-seo--text .row').outerHeight(); // Trouver le texte spécifique
    if ($wrapper.find('.blocs-seo--text').hasClass('is-active')) {
      $wrapper.find('.blocs-seo--text').removeClass('is-active');
    } else {
      $("body").get(0).style.setProperty("--text-seo-height", detailsHeightInnerSeo + 'px');
      $wrapper.find('.blocs-seo--text').removeClass('is-active');
      $wrapper.find('.blocs-seo--text').addClass('is-active');
    }
  });

  $('.seo-block--element').on('click', function() {
    let detailsHeightInner = $(this).find('.seo-block--details .row').outerHeight()
    if($(this).is('.is-active')) {
      $(this).removeClass('is-active');
    } else {
      $("body").get(0).style.setProperty("--seo-block-height", detailsHeightInner + 'px');
      $('.seo-block--element').removeClass('is-active');
      $(this).addClass('is-active');
    }
  });
}

export function initSeoBlockMore($) {
  /* ========================================================================= *\
  **  === SEO BLOCK                                                            *| 
  \* ========================================================================= */
  $('.seo-block--see-more').on('click', function(){
		$('.seo-block--content').addClass('is-active');
		$('.seo-block--see-more').hide()
		$('.seo-block--see-less').show()
	})
	$('.seo-block--see-less').on('click', function(){
		$('.seo-block--content').removeClass('is-active');
		$('.seo-block--see-more').show()
		$('.seo-block--see-less').hide()
	})

  // $('.see-more').on('click', function(){
	// 	$('.seo-block').addClass('is-active');
	// 	$('.see-more').addClass('d-none');
	// 	$('.see-less').addClass('d-block');
	// })
	// $('.see-less').on('click', function(){
	// 	$('.seo-block').removeClass('is-active');
	// 	$('.see-more').addClass('d-block');
	// 	$('.see-less').addClass('d-none');
	// })
}
